// icons/pet.svg

export const PetIconV2 = (props) => (
  <svg
    className={props.className}
    width="33"
    height="29"
    viewBox="0 0 33 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4999 14.0916C21.8082 14.0916 26.0957 16.7457 26.0957 20.0124C26.0957 23.2791 21.604 25.9332 16.4999 25.9332C11.3957 25.9332 6.90405 23.2791 6.90405 20.0124C6.90405 16.7457 11.1915 14.0916 16.4999 14.0916ZM16.4999 11.0291C9.55821 11.0291 3.84155 15.1124 3.84155 20.0124C3.84155 24.9124 9.55821 28.9957 16.4999 28.9957C23.4415 28.9957 29.1582 24.9124 29.1582 20.0124C29.1582 15.1124 23.4415 11.0291 16.4999 11.0291Z"
      fill="#34363E"
    />
    <path
      d="M3.84163 12.8666C5.87128 12.8666 7.51664 11.2213 7.51664 9.19161C7.51664 7.16196 5.87128 5.5166 3.84163 5.5166C1.81199 5.5166 0.166626 7.16196 0.166626 9.19161C0.166626 11.2213 1.81199 12.8666 3.84163 12.8666Z"
      fill="#34363E"
    />
    <path
      d="M10.9875 7.55825C13.0172 7.55825 14.6625 5.91289 14.6625 3.88324C14.6625 1.8536 13.0172 0.208252 10.9875 0.208252C8.95786 0.208252 7.3125 1.8536 7.3125 3.88324C7.3125 5.91289 8.95786 7.55825 10.9875 7.55825Z"
      fill="#34363E"
    />
    <path
      d="M29.1584 12.8666C31.1881 12.8666 32.8334 11.2213 32.8334 9.19161C32.8334 7.16196 31.1881 5.5166 29.1584 5.5166C27.1288 5.5166 25.4834 7.16196 25.4834 9.19161C25.4834 11.2213 27.1288 12.8666 29.1584 12.8666Z"
      fill="#34363E"
    />
    <path
      d="M22.0125 7.55825C24.0422 7.55825 25.6875 5.91289 25.6875 3.88324C25.6875 1.8536 24.0422 0.208252 22.0125 0.208252C19.9829 0.208252 18.3375 1.8536 18.3375 3.88324C18.3375 5.91289 19.9829 7.55825 22.0125 7.55825Z"
      fill="#34363E"
    />
  </svg>
);
